<!-- Básica -->
<div class="row" *ngIf="isBasica">
  <div class="col-lg col-md col-xs col-xl col-sm w-100">
    <mat-card class="mat-elevation-z8 w-100">
      <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
        <div class="row">
          <div class="col-lg col-md col-xs col-xl col-sm">
            <p class="tituloLeft">{{ step }}</p>
          </div>
          <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
            <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
              *ngIf="!collapseCard"></i>
            <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
              *ngIf="collapseCard"></i>
          </div>
        </div>
        <mat-card-content *ngIf="!collapseCard">

          <div class="row pt-3">
            <div class="col-lg-6 col-md-6">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Responsável pela Análise </mat-label>
                <input matInput id="txtResponsavelAnalise" #txtResponsavelAnalise maxlength="35"
                  formControlName="responsavel_analise" />
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                <!-- <mat-error>{{
                  hasErrorFormControl(formulario.controls.destino)
                }}</mat-error> -->
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Número do Passe</mat-label>
                <mat-select #txtNumeroPasse formControlName="previa_numero_passada_basica" (selectionChange)="changePasseOrRegulagem()" disableCenteringOption>
                  <input matInput type="txtNumeroPasse" class="form-control filterTxt" placeholder="Pesquisar por..."
                    (keyup)="createFilterPreviaNumeroPassada($event.target.value)">
                  <mat-option *ngFor="let item of listPreviaNumeroPassada" [value]="item.name">
                    {{item.name | uppercase}}
                  </mat-option>
                </mat-select>
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{msgAvisoPasse}}</mat-hint>
                <!-- <mat-error>{{hasErrorFormControl(formulario.controls.lote_cs)}}</mat-error> -->
              </mat-form-field>
            </div>
          </div>

          <div class="row pt-3">
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Número de Regulagens</mat-label>
                <mat-select #txtNumeroRegulagens formControlName="regulagem_passe" (selectionChange)="changePasseOrRegulagem()" disableCenteringOption>
                  <input matInput type="txtNumeroPasse" class="form-control filterTxt" placeholder="Pesquisar por..."
                    (keyup)="createFilterRegulagemPasse($event.target.value)">
                  <mat-option *ngFor="let item of listRegulagemPasse" [value]="item.name">
                    {{item.name | uppercase}}
                  </mat-option>
                </mat-select>
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{msgAvisoRegulagem}}</mat-hint>
                <!-- <mat-error>{{hasErrorFormControl(formulario.controls.lote_cs)}}</mat-error> -->
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Liberação Especial</mat-label>
                <mat-select #txtLiberacaoEspecial formControlName="liberacao_especial" (selectionChange)="changeSelect($event)"
                  disableCenteringOption [(ngModel)]="ngSelectedliberacaoEspecial">
                  <input matInput type="text" class="form-control filterTxt" placeholder="Pesquisar por..."
                    (keyup)="createFilterLiberacaoEspecial($event.target.value)" />
                  <mat-option *ngFor="let item of listLiberacaoEspecial" [value]="item.name">
                    {{ item.name | uppercase }}
                  </mat-option>
                </mat-select>
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                <!-- <mat-error>
                            {{ hasErrorFormControl(formulario.controls.liberacao_especial) }}
                          </mat-error> -->
              </mat-form-field>
            </div>
          </div>

          <div class="row pt-3">
            <div class="col-lg-6 col-md-6">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Motivo Liberação Especial</mat-label>
                <input matInput id="txtMotivoLiberacaoEspecial" #txtMotivoLiberacaoEspecial maxlength="20"
                  formControlName="motivo_liberacao_especial" />
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">Ex.: Aprovação somente em disco Apollo;
                  Direcionamento especial (plantio à vácuo)</mat-hint>
                <mat-hint align="end">{{ txtMotivoLiberacaoEspecial.value.length }} / 20</mat-hint>
                <!-- <mat-error>{{
                            hasErrorFormControl(formulario.controls.motivo_liberacao_especial)
                          }}</mat-error> -->
              </mat-form-field>
            </div>
            <div class="col-lg-6 col-md-6">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Responsável pela Autorização Especial </mat-label>
                <input matInput id="txtResponsavelAutorizacaoEspecial" #txtResponsavelAutorizacaoEspecial maxlength="35"
                  formControlName="responsavel_autorizacao_especial" />
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                <!-- <mat-error>{{
                  hasErrorFormControl(formulario.controls.destino)
                }}</mat-error> -->
              </mat-form-field>
            </div>
          </div>
          <div class="row pt-3">
            <div class="col-lg-4 col-md-4">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Avaliação Retenção </mat-label>
                <input matInput id="txtAvaliacaoRetencao" #txtAvaliacaoRetencao maxlength="35"
                  formControlName="avaliacao_retencao" class="InputBlockColor" readonly />
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                <!-- <mat-error>{{
                  hasErrorFormControl(formulario.controls.destino)
                }}</mat-error> -->
              </mat-form-field>
            </div>
            <div class="col-lg-4 col-md-4">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Avaliação Precision Planting </mat-label>
                <input matInput id="txtAvaliacaoPrecisionPlanting" #txtAvaliacaoPrecisionPlanting maxlength="35"
                  formControlName="avaliacao_precision_planting" class="InputBlockColor" readonly />
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                <!-- <mat-error>{{
                  hasErrorFormControl(formulario.controls.destino)
                }}</mat-error> -->
              </mat-form-field>
            </div>
            <div class="col-lg-4 col-md-4">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                  floatLabel="{{formFieldFloatLabel}}">
                  <mat-label class="InputLabelColor">Usuário</mat-label>
                  <input matInput id="txtUsuario" #txtUsuario maxlength="100" formControlName="usuario"
                      readonly class="InputBlockColor">
                  <i matSuffix class="{{iconDisableField}}"></i>
                  <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                  <mat-hint align="end">{{txtUsuario.value.length}} / 100</mat-hint>
                  <mat-error>{{hasErrorFormControl(formulario.controls.usuario)}}</mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="row pt-3">
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                      floatLabel="{{formFieldFloatLabel}}">
                      <mat-label class="InputLabelColor">Criado por</mat-label>
                      <input matInput id="txtCriadoPor" #txtCriadoPor maxlength="40"
                          formControlName="criado_por" readonly class="InputBlockColor">
                      <i matSuffix class="{{iconDisableField}}"></i>
                      <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                      <mat-hint align="end">{{txtCriadoPor.value.length}} / 40</mat-hint>
                      <mat-error>{{hasErrorFormControl(formulario.controls.criado_por)}}
                      </mat-error>
              </mat-form-field>
            </div>
          </div>
        </mat-card-content>
      </form>
    </mat-card>
  </div>
</div>
